const urlParse = require('url-parse');
const forge = require('node-forge');
const rsa = forge.pki.rsa;

/**
* @class IDMUtils
* @classdesc IDM Utils is a utility class with static util methods available
* anywere in the code. This class is not exported with IDM module to be used
* on clients.
 */
export default class IDMUtils {}
/**
 * isValidString - Check if input is a valid string with length bigger than 0.
 * @public
 * @param  {string} string String to be checked
 * @return {boolean}       Return if is a valid string
 */
IDMUtils.isValidString = function(string) { return (string && string.length > 0 && !Array.isArray(string)); }

/**
 * isValidNumber - Check if input is a valid number.
 *
 * @param  {number} number description
 * @return {boolean}       Return if is a valid number
 */
IDMUtils.isValidNumber = function(number) {
  let validNumb = NaN;
  try { validNumb = parseInt(number + ""); }
  catch (e) { console.log(e) }
  return !isNaN(validNumb) && !Array.isArray(number);
}
/**
 * caseInsensitiveObjectForKey - Get object by key with case insesitiveness
 * on the key.
 *
 * @param  {object} obj Object to be searched for the key
 * @param  {string} key The key to be searched on the object
 * @return {any}        The found value or null if not found.
 */
IDMUtils.caseInsensitiveObjectForKey = function(obj, key) {
  if (!obj) return null;
  const insensitiveKey = Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
  if (insensitiveKey && insensitiveKey != '') return obj[insensitiveKey];
  return null;
}

/**
 * caseInsensitiveObjectForKeyOnArray - Get object by key with case insesitiveness
 * on the key searching on an array.
 *
 * @param  {array} obj Object to be searched for the key
 * @param  {string} key The key to be searched on the object
 * @return {any}        The found value or null if not found.
 */
IDMUtils.caseInsensitiveObjectForKeyOnArray = function(obj, key) {
  if (!obj) return null;
  for (let sub of obj) {
    if (sub.key.toLowerCase() == key.toLowerCase()) return sub.value;
  } return null;
}

/**
 * caseInsensitiveSetObjectForKey - Set object by key with case insesitiveness
 * on the key.
 *
 * @param  {object} obj  The obejct to have the key/value inserted
 * @param  {string} key  The key of the value to be inserted
 * @param  {any} value   The value to be inserted with the key
 * @return {object}      Specified object with the new key/value
 */
IDMUtils.caseInsensitiveSetObjectForKey = function(obj, key, value) {
  if (!obj) obj = {};
  const insensitiveKey = Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
  if (insensitiveKey && insensitiveKey != '') obj[insensitiveKey] = value;
  else obj[key] = value;
  return obj;
}

/**
 * isNodeJS - Check if its on nodejs enviroment or browser.
 *
 * @return {boolean}  Return true if running on nodejs enviroment.
 */
IDMUtils.isNodeJS = function() {
  let root = this;
  let _ = new Object();
  let isNode = false;
  // Export the Underscore object for **CommonJS**, with backwards-compatibility
  // for the old `require()` API. If we're not in CommonJS, add `_` to the
  // global object.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = _;
    root._ = _;
    isNode = true;
  } else root._ = _;
  return isNode;
}


// Browser
IDMUtils.openExternalPage = function(url, appendProtocol) {
  if (appendProtocol) {
    const curr = urlParse(window.location.href);
    url = `${curr.protocol.replace(':','')}://${url}`;
  }
  window.open(url, '_blank');
  window.focus();
}
IDMUtils.isSafari = function() {
  if (IDMUtils.isNodeJS()) return false;
  return !!(navigator && navigator.userAgent && navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
}
//BROWSER stuff
IDMUtils.dataURItoBlob = function (dataURI) { //got from https://gist.github.com/davoclavo/4424731
  return Buffer.from(dataURI.replace(/^data:image\/\w+;base64,/, "").replace(/^data:application\/\w+;base64,/, ""), 'base64');
}
//Date
IDMUtils.timestampAfterHours = function (hours) {
  return IDMUtils.timestampAfterHoursFromDate(hours, new Date());
}
IDMUtils.timestampAfterHoursFromDate = function (hours, date) {
  date = new Date(date);
  date.setHours(date.getHours() + hours);
  return date.getTime();
}

/* Crypto */
IDMUtils.encryptPKCS = function(publicKey, object) {
  return forge.util.encode64(publicKey.encrypt(object, 'RSAES-PKCS1-V1_5'))
}
IDMUtils.decryptPKCS = function(privateKey, hash) {
  return privateKey.decrypt(forge.util.decode64(hash), 'RSAES-PKCS1-V1_5')
}
